import { render } from "./PasswordResetConfirm.vue?vue&type=template&id=74d37496"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__